import React, { useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ImageHero, RootineStepper, StepConfig, StepperProps } from '../atoms';
import { Onboarding, OnboardingProps } from './Onboarding';

import { useModal } from 'mui-modal-provider';
import { useMe } from '../config/api/queries';
import { theme } from '../utils/theme';
const steps: StepConfig[] = [
  {
    name: 'quiz',
    title: 'STEP 1',
    detail: 'Complete lifestyle questionnaire',
    icon: (
      <CheckCircleIcon sx={{ color: 'info.main', backgroundColor: 'white' }} />
    ),
  },
  {
    name: 'order',
    title: 'STEP 2',
    detail: 'Order your health tests and precision multivitamin membership',
    icon: (
      <CheckCircleIcon sx={{ color: 'info.main', backgroundColor: 'white' }} />
    ),
  },
  {
    name: 'analyze',
    title: 'STEP 3',
    detail: 'We analyze your health tests and data uploads',
    icon: (
      <CheckCircleIcon sx={{ color: 'info.main', backgroundColor: 'white' }} />
    ),
  },
  {
    name: 'ship',
    title: 'STEP 4',
    detail:
      'Based on your results, we ship your precision multivitamins to your door',
    icon: (
      <CheckCircleIcon sx={{ color: 'info.main', backgroundColor: 'white' }} />
    ),
  },
];

export const Journey = (): JSX.Element => {
  const me = useMe();
  const { showModal } = useModal();
  const [currentStep, setCurrentStep] = useState<number>();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (me?.data) {
      const user = me?.data;
      const hasVitamins = user.subscription_status === 'active';
      const hasDNA = user.dna_result;
      const hasBlood = user.blood_result;
      const pendingDNA =
        user.dna_status !== '' && user.dna_status !== 'available';
      const pendingBlood =
        user.vitamin_test_status !== '' &&
        user.vitamin_test_status !== 'available';
      const lifestyleQuizUser =
        user.vitamin_test_status === '' &&
        user.dna_status === '' &&
        user.hormone_status === '';
      if (hasVitamins && (pendingDNA || pendingBlood)) {
        setCurrentStep(1);
      } else if (user.vitamins_in_shipping && hasVitamins) {
        setCurrentStep(2);
      } else if (!user.vitamins_in_shipping && hasVitamins) {
        setCurrentStep(steps.length);
      } else if (hasDNA && hasBlood && hasVitamins) {
        setCurrentStep(steps.length);
      } else if (lifestyleQuizUser) {
        setCurrentStep(0);
      } else {
        const testOnly = hasDNA && hasBlood && !hasVitamins;
        const dnaOnly = hasDNA && !hasBlood && !hasVitamins;
        const bloodOnly = hasBlood && !hasDNA && !hasVitamins;
        const vitaminsOnly = !hasBlood && !hasDNA && hasVitamins;
        let result_text = steps[1].detail;
        const purchasedAll =
          user.vitamin_test_status !== '' &&
          user.dna_status !== '' &&
          hasVitamins;
        if (purchasedAll) {
          result_text = 'Complete your test and send it to our lab';
        } else if (vitaminsOnly) {
          result_text = 'Order your health tests';
        } else if (bloodOnly) {
          result_text =
            'Order your DNA test and precision multivitamin membership';
        } else if (dnaOnly) {
          result_text =
            'Order your Blood test and precision multivitamin membership';
        } else if (testOnly) {
          result_text = 'Order your precision multivitamin membership';
        }
        steps[1].detail = result_text;
        // setCurrentStep(0);
      }
    }
  }, [me?.data, steps]);

  const addToCart = () => {
    const onboardingProps: OnboardingProps = {
      cartOnly: true,
    };
    showModal(Onboarding, { ...onboardingProps });
  };

  const stepProps: StepperProps = {
    steps: steps,
    activeStep: currentStep,
    orientation: isMobile ? 'vertical' : 'horizontal',
    connectorColor: '#000',
    activeColor: '#0075FF',
    onClick: () => addToCart(),
  };

  return currentStep === steps.length ? (
    <></>
  ) : (
    <Grid item xs={12}>
      <ImageHero
        image="/images/rootine_product_suite.png"
        alttext="person taking vitamins"
        title={
          me?.data?.vitamins_in_shipping
            ? 'Your Rootine is on the way!'
            : 'Your Rootine Journey Starts Here'
        }
        height={isMobile ? 110 : 360}
      />
      {/* <RootineStepper {...stepProps} /> */}
    </Grid>
  );
};
